import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux';

import history from '../utils/history';
import LocalDB from '../utils/localDB';
import { getCurrentUser } from '../utils/user-utils';

class AdminSidebar extends Component {
  constructor(props) {
    super(props);

    const { sbOpen, sbPosition } = LocalDB.fetch('sbProps') || {
      sbPosition: 0,
      sbOpen: false
    };

    this.state = {
      sbOpen,
      sbPosition
    };
  }

  componentDidMount() {
    const sidebar = $('.sidebar'),
      _this = this;

    sidebar.scrollTop(this.state.sbPosition);

    sidebar.on('scroll', e => {
      _this.setState({ sbPosition: sidebar.scrollTop() });
    });
  }

  componentWillUnmount() {
    LocalDB.insert('sbProps', this.state);
  }

  _toggleSidebar(e) {
    this.setState({ sbOpen: !this.state.sbOpen });
  }

  buildMenuItem(menu, key) {
    const { route, font, name } = menu;
    let menuItem = '';

    if (menu.hasOwnProperty('divider')) {
      menuItem = (
        <li className="divider" key={key}>
          {menu.divider}
        </li>
      );
    } else {
      menuItem = (
        <li key={key}>
          <NavLink to={route}>
            <i className={font} />
            <span>{name}</span>
          </NavLink>
        </li>
      );
    }

    return menuItem;
  }

  buildSideBar = role => {
    let listItems = [];
    listItems.push({ divider: 'Main' });
    listItems.push({
      route: '/dashboard',
      font: 'ion ion-ios-home',
      name: 'Dashboard',
      permissions: []
    });

    switch (role) {
      case 'corporate_agent':
      case 'sailor':
      case 'intermediary_agent':
      case 'sales_admin':
        listItems.push({ divider: 'Policies' });
        listItems.push({
          route: '/brokers-agencies',
          font: 'ion ion-ribbon-b',
          name: 'Brokers/Agencies',
          permissions: []
        });
        listItems.push({
          route: '/quote',
          font: 'ion ion-android-cart',
          name: 'Buy',
          permissions: []
        });
        listItems.push({
          route: '/pending-quotes',
          font: 'ion ion-compose',
          name: 'Pending Quotes',
          permissions: []
        });
        listItems.push({
          route: '/certificates',
          font: 'ion ion-ribbon-b',
          name: 'MCI Certificates',
          permissions: []
        });
        listItems.push({
          route: '/fileclaims',
          font: 'ion ion-document',
          name: 'File Claim',
          permissions: []
        });

        break;
      case 'underwriter_admin':
        listItems.push({ divider: 'Policies' });
        listItems.push({
          route: '/discounts',
          font: 'ion ion-pie-graph',
          name: 'Discounts',
          permissions: []
        });

      case 'insurer_admin':
      case 'underwriter_admin':
      case 'branch_admin':
        listItems.push({ divider: 'Policies' });
        listItems.push({
          route: '/pending-quotes',
          font: 'ion ion-compose',
          name: 'Pending Quotes',
          permissions: []
        });
        listItems.push({
          route: '/qoutes',
          font: 'ion ion-document-text',
          name: 'Paginated Quotes',
          permissions: []
        });
        listItems.push({
          route: '/policies',
          font: 'ion ion-document-text',
          name: 'Policies',
          permissions: []
        });

        listItems.push({
          route: '/expired',
          font: 'ion ion-archive',
          name: 'Expired Policies',
          permissions: []
        });
        listItems.push({
          route: '/expired',
          font: 'ion ion-document-text',
          name: 'Expired Policies',
          permissions: []
        });
        listItems.push({
          route: '/open-covers',
          font: 'ion ion-folder',
          name: 'Open Covers',
          permissions: []
        });
        listItems.push({
          route: '/uploads',
          font: 'ion ion-upload',
          name: 'Upload Policies',
          permissions: []
        });
        listItems.push({
          route: '/claims',
          font: 'ion ion-document-text',
          name: 'Claims',
          permissions: []
        });
        listItems.push({
          route: '/reports',
          font: 'ion ion-pie-graph',
          name: 'Reports',
          permissions: []
        });
        listItems.push({
          route: '/revenue',
          font: 'ion ion-stats-bars',
          name: 'Revenue',
          permissions: []
        });

        listItems.push({ divider: 'Payments' });
        listItems.push({
          route: '/received-payments',
          font: 'ion ion-card',
          name: 'Received Payments',
          permissions: []
        });
        listItems.push({
          route: '/commissions',
          font: 'ion ion-social-usd',
          name: 'Commissions',
          permissions: []
        });

        listItems.push({ divider: 'Corporate' });
        listItems.push({
          route: '/brokers-agencies',
          font: 'ion ion-ribbon-b',
          name: 'Brokers/Agencies',
          permissions: []
        });

        listItems.push({ divider: 'Rates' });
        listItems.push({
          route: '/currency-rates',
          font: 'ion ion-cash',
          name: 'Currency Rates',
          permissions: []
        });
        listItems.push({
          route: '/goods-rates',
          font: 'ion ion-ios-calculator',
          name: 'Premium Rates',
          permissions: []
        });
        listItems.push({
          route: '/limits',
          font: 'ion ion-ios-calculator',
          name: 'Limits',
          permissions: []
        });
        listItems.push({
          route: '/other-rates',
          font: 'ion ion-ios-calculator',
          name: 'Other Rates',
          permissions: []
        });

        listItems.push({ divider: 'Regions and Ports' });
        listItems.push({
          route: '/regions',
          font: 'ion ion-map',
          name: 'Regions',
          permissions: []
        });
        listItems.push({
          route: '/branches',
          font: 'ion ion-network',
          name: 'Branches',
          permissions: []
        });
        listItems.push({
          route: '/flagged',
          font: 'ion ion-alert',
          name: 'Flagged',
          permissions: []
        });

        listItems.push({ divider: 'Documents' });
        listItems.push({
          route: '/certificates',
          font: 'ion ion-ribbon-b',
          name: 'MCI Certificates',
          permissions: []
        });
        listItems.push({
          route: '/policy-document',
          font: 'ion ion-document',
          name: 'Policy Document',
          permissions: []
        });

        listItems.push({ divider: 'User Management' });
        listItems.push({
          route: '/users-permissions',
          font: 'ion ion-locked',
          name: 'User Permissions',
          permissions: []
        });

        break;

      case 'intermediary_admin':
        listItems.push({ divider: 'Policies' });
        listItems.push({
          route: '/quote',
          font: 'ion ion-android-cart',
          name: 'Buy',
          permissions: []
        });
        listItems.push({
          route: '/pending-quotes',
          font: 'ion ion-compose',
          name: 'Pending Quotes',
          permissions: []
        });
        listItems.push({
          route: '/certificates',
          font: 'ion ion-ribbon-b',
          name: 'MCI Certificates',
          permissions: []
        });
        listItems.push({
          route: '/premium-deposist',
          font: 'ion ion-document-text',
          name: 'Premium Deposit',
          permissions: []
        });
        listItems.push({
          route: '/fileclaims',
          font: 'ion ion-document-text',
          name: 'File Claim',
          permissions: []
        });
        break;

      case 'broker_association_admin':
      case 'port_authority':
        listItems.push({ route: '/', font: '', name: '', permissions: [] });

        break;

      case 'tax_agency_admin':
        listItems.push({
          route: '/verify-policy',
          font: 'ion ion-document-text',
          name: 'Verify Policy',
          permissions: []
        });

        break;

      case 'insurer_regulator':
      case 'insurer_association_admin':
      case 'sinbad_admin':
        listItems.push({ divider: 'Policies' });
        listItems.push({
          route: '/pending-quotes',
          font: 'ion ion-compose',
          name: 'Pending Quotes',
          permissions: []
        });
        listItems.push({
          route: '/policies',
          font: 'ion ion-document-text',
          name: 'Policies',
          permissions: []
        });
        listItems.push({
          route: '/expired',
          font: 'ion ion-document-text',
          name: 'Expired Policies',
          permissions: []
        });
        listItems.push({
          route: '/open-covers',
          font: 'ion ion-folder',
          name: 'Open Covers',
          permissions: []
        });
        listItems.push({
          route: '/uploads',
          font: 'ion ion-upload',
          name: 'Upload Policies',
          permissions: []
        });
        listItems.push({
          route: '/expired',
          font: 'ion ion-archive',
          name: 'Expired Policies',
          permissions: []
        });
        listItems.push({
          route: '/claims',
          font: 'ion ion-document-text',
          name: 'Claims',
          permissions: []
        });
        listItems.push({
          route: '/reports',
          font: 'ion ion-pie-graph',
          name: 'Reports',
          permissions: []
        });

        listItems.push({ divider: 'Payments' });
        listItems.push({
          route: '/received-payments',
          font: 'ion ion-card',
          name: 'Received Payments',
          permissions: []
        });
        listItems.push({
          route: '/commissions',
          font: 'ion ion-social-usd',
          name: 'Commissions',
          permissions: []
        });

        listItems.push({ divider: 'Corporate' });
        listItems.push({
          route: '/insurers',
          font: 'ion ion-umbrella',
          name: 'Insurers',
          permissions: []
        });
        listItems.push({
          route: '/branches',
          font: 'ion ion-network',
          name: 'Branches',
          permissions: []
        });
        listItems.push({
          route: '/brokers-agencies',
          font: 'ion ion-ribbon-b',
          name: 'Brokers/Agencies',
          permissions: []
        });

        listItems.push({ divider: 'Rates' });
        listItems.push({
          route: '/currency-rates',
          font: 'ion ion-cash',
          name: 'Currency Rates',
          permissions: []
        });
        listItems.push({
          route: '/goods-rates',
          font: 'ion ion-ios-calculator',
          name: 'Premium Rates',
          permissions: []
        });
        // listItems.push({route: '/limits', font: 'ion ion-ios-calculator', name: 'Limits', permissions: []});
        listItems.push({
          route: '/other-rates',
          font: 'ion ion-ios-calculator',
          name: 'Other Rates',
          permissions: []
        });

        listItems.push({ divider: 'Regions and Ports' });
        listItems.push({
          route: '/regions',
          font: 'ion ion-map',
          name: 'Regions',
          permissions: []
        });

        //listItems.push({route: '/flagged', font: 'ion ion-alert', name: 'Flagged', permissions: []});

        listItems.push({ divider: 'Documents' });
        listItems.push({
          route: '/certificates',
          font: 'ion ion-ribbon-b',
          name: 'MCI Certificates',
          permissions: []
        });

        listItems.push({ divider: 'User Management' });
        listItems.push({
          route: '/users',
          font: 'ion ion-locked',
          name: 'Users',
          permissions: []
        });
        listItems.push({
          route: '/users-permissions',
          font: 'ion ion-locked',
          name: 'Underwriter Users',
          permissions: []
        });

        break;

      default:
        break;
    }
    return listItems;
  };

  render() {
    const { sbOpen } = this.state;
    const { user } = this.props;

    const currentUser = getCurrentUser(user);
    let menuItems = [];

    if (currentUser) {
      let role = currentUser.role;
      menuItems = this.buildSideBar(role);
    } else {
      history.push('login-register');
    }

    return (
      <div className="sidebar admin-sidebar clearfix">
        <button
          className="btn admin-sidebar-toggle hidden"
          onClick={() => {
            this._toggleSidebar();
          }}
        >
          <i
            className={
              'ion ion-chevron-' + (sbOpen === true ? 'left' : 'right')
            }
          />
        </button>
        <div className="title-label">TIIP</div>

        <ul className={'nav nav-pills nav-stacked admin-sidebar'}>
          <li>
            <NavLink exact to="/">
              <i className="ion ion-ios-arrow-back" />
              <span>Back to Main Site</span>
            </NavLink>
          </li>
          {menuItems.map((menu, key) => {
            return this.buildMenuItem(menu, key);
          })}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

export default connect(mapStateToProps)(AdminSidebar);



// WEBPACK FOOTER //
// ./src/components/AdminSidebar.jsx